export default class Constants {
  public static LOG_LEVEL = class {
    static ERROR = 'error';
    static INFO = 'info';
  };
}
